import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Logo } from '@els/els-react--logo';
import { possibleResults } from '../ForgotPasswordDialogConstants';

function ForgotPasswordDialogHeader({ result }) {
  return (
    <div className="forgot-password-dialog__header u-els-padding-top-1o2">
      <Logo className="logo u-els-padding-bottom-1x1o2" />
      <h1 className="u-els-padding-bottom u-els-font-size-h3 u-els-color-text">
        {result === possibleResults.success ? 'Check your inbox' : 'Password recovery'}
      </h1>
    </div>
  );
}

ForgotPasswordDialogHeader.propTypes = {
  result: PropTypes.string,
};

export default ForgotPasswordDialogHeader;
